<template>
  <span>
    <div
      v-if="title"
      class="data-title"
    >
      {{ title }}
    </div>
    <div
      v-if="subtitle"
      class="data-subtitle"
    >
      {{ subtitle }}
    </div>
    <div
      v-if="$slots.default"
      class="data-info"
      :class="(textarea ? ' data-description' : '') + (icon ? ' with-icon' : '')"
      :style="icon ? `background-image: url(${icon})` : ''"
    >
      <slot />
    </div>
  </span>
</template>

<script>
export default {
  props: {
    textarea: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
  .data-title {
    font-size: 0.875rem;
    font-weight: 700;
    margin-bottom: 0.35rem;
  }
  .data-subtitle {
    font-size: 0.75rem;
    margin-bottom: 0.25rem;
  }
  .data-info {
    display: inline-block;
    border: 2px solid $nh-gray;
    border-radius: 5px;
    padding: 0.5rem;
    font-size: 0.75rem;
    &.with-icon {
      background-repeat: no-repeat;
      background-position: 4px center;
      background-size: 20px;
      padding-left: 1.9rem;
    }
  }
  .data-description {
    display: block;
    white-space: pre-line;
    color: #53585D;
    strong {
      color: black;
    }
  }
</style>
